@if (ready) {
<ng-container *ngTemplateOutlet="companyProductsList; context:{ plans: rootPlans }" />
}
<ng-template #companyProductsList let-plans="plans" let-parentList="parentList" let-parent="parent">
	<list-view #listView scrollable [referenceName]="parentList ? 'childs-to-' + parent : 'main'" [parentList]="parentList" [selectable]="false">
		<header [sortColumn]="sortColumns">{{ 'company.product-plans.product-name' | translate }}</header>
		<header [sortColumn]="sortColumns">{{ 'company.accounting-plans.start-date' | translate }}</header>
		<header [sortColumn]="sortColumns" defaultSort="descending">{{ 'company.accounting-plans.end-date' | translate }}</header>
		<header [sortColumn]="sortColumns" align-right>{{ 'company.accounting-plans.interval-months' | translate }}</header>
		<header [sortColumn]="sortColumns" align-right>{{ 'company.accounting-plans.total-value' | translate }}</header>
		<row *listData="let plan from plans"
			[highlighted]="multiSelectFilter ? selectedProductPlans.indexOf(plan) >= 0 : selectedProductPlan == plan"
			[select]="multiSelectFilter ? false : selectedProductPlan == plan"
			[clickable]="multiSelectFilter ? multiSelectFilter(plan) : true"
			(action)="selectProductPlan(plan);"
			[statusColor]="statusColor(plan)"
			[statusTitle]="statusText(plan) | translate"
			[brand]="plan.brandId"
			[attr.data-id]="plan.id"
			[showCollapseIcon]="true"
			[hidden]="!showPlan(plan, !parentList)"
			[collapsed]="plan.inverseParent.length > 0 ? false : undefined"
			(collapsedChange)="plan.collapsed = $event">

			<column>{{ plan | productName }}</column>
			<column [sortValue]="activeAccountingPlans.get(plan)?.startDate">{{ activeAccountingPlans.get(plan)?.startDate | customDate: 'shortDate' }}</column>
			<column [sortValue]="activeAccountingPlans.get(plan)?.endDate">{{ (plan.autoRenewable ? activeAccountingPlans.get(plan)?.endDate : undefined) | customDate: 'shortDate' }}</column>
			<column align-right>{{ (activeAccountingPlans.get(plan)?.startDate ? activeAccountingPlans.get(plan)?.paymentInterval : plan.paymentScheme) | paymentInterval:{ installments: activeAccountingPlans.get(plan)?.numberOfInstallments, accountingPlan: activeAccountingPlans.get(plan) } }}</column>
			<column align-right [sortValue]="activeAccountingPlans.get(plan)?.totalPlanValue">{{ activeAccountingPlans.get(plan)?.totalPlanValue | currency }}</column>

			@if (plan.inverseParent && plan.inverseParent.length > 0 && !plan.collapsed && (showInactivePlans || plan.show)) {
				<ng-container *ngTemplateOutlet="companyProductsList; context:{ plans: plan.inverseParent, parentList: listView, parent: plan.id}" />
			}
		</row>
	</list-view>
</ng-template>
@if (ready && !onlyActivePlans) {
	<section>
		@if (hasInactivePlans) {
			<custom-input [inputType]="inputTypeEnum.Switch"
						  [(value)]="showInactivePlans"
						  [label]="'company-products.show-inactive-plans' | translate" />
			}
		@if (!hasInactivePlans) {
			{{ 'company-products.no-inactive-plans' | translate }}
		}
	</section>
}
